<template>
  <div
    v-if="isEnabled && universityID && terms.length && href"
    :key="uniqueSlug"
  >
    <script
      async
      defer
      src="https://cdn.theaccessplatform.com/popcard.js"
      type="application/javascript"
    ></script>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheAccessPlatform',

  computed: {
    ...mapGetters([ 'myStore', 'tapFilterObj' ]),
    // Admin
    isAdminEnabled() { return this.myStore(['settings', 'tap_enabled']) ?? false },
    // Site options
    tapOptions() { return this.myStore(['options', 'tap']) ?? {} },
    isClientEnabled() { return this.tapOptions.enabled ?? false },
    universityID() { return this.tapOptions.university_id },
    // Store
    terms() { return this.tapFilterObj.terms || [] },
    href() { return this.tapFilterObj.href || '' },
    // Component
    isEnabled() { return this.isAdminEnabled && this.isClientEnabled },
    uniqueSlug() { return `tap-uni-${this.universityID || 0}-terms-${this.terms.join('_') || 'none'}-href-${this.href || 'none'}` },
  },

  watch: {
    uniqueSlug() { this.updateWindowData() }
  },

  beforeMount() {
    if (!window.mw || !window.mw.q) { this.addWindowData() }
    this.updateWindowData()
  },

  methods: {
    removeIframe() {
      const $script = document.getElementById('mw')
      if ($script) { $script.parentNode.removeChild($script) }
      const $iframe = document.getElementById('tap-pop-card')
      if ($iframe) { $iframe.parentNode.removeChild($iframe) }
    },
    addWindowData() {
      window.popCard = 'mw'
      // this differs from stock code as we need the array to contain only the new term args, not push to a list
      window.mw = window.mw || function() { (window.mw.q = []).push(arguments) }
    },
    updateWindowData() {
      this.removeIframe()
      if (!this.universityID || !this.terms.length || !this.href) { return }
      window.mw('init', {
        universityID: this.universityID,
        terms: this.terms,
        href: this.href
      })
    }
  }
}
</script>

